(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/race-handler/common/logger.js') >= 0) return;  svs.modules.push('/components/sport/race-handler/common/logger.js');
'use strict';

const LOGGER_NAME = svs.components.sport.raceHandler.common.constants.LOGGER_NAME;
const log = svs.core.log;
const logger = log.getLogger(LOGGER_NAME);
setGlobal('svs.components.sport.raceHandler.logger', logger);

 })(window);